import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ApplicationInsightsService } from "@ankaadia/ankaadia-shared-frontend";
import { ButtonDirective } from "primeng/button";
import { Observable } from "rxjs";
import { NewUiErrorPageComponent } from "../../shared/error-page/new-ui-error-page.component";
import { SettingsService } from "../../shared/services/settings.service";
import { TranslateDirective } from "../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-access-denied",
  templateUrl: "./new-ui-access-denied.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, AsyncPipe, RouterLink, ButtonDirective, NewUiErrorPageComponent],
})
export class NewUiAccessDeniedComponent implements OnInit {
  loggedIn: Observable<boolean>;
  errorMessage: string = null;

  constructor(
    private readonly settings: SettingsService,
    private readonly appInsights: ApplicationInsightsService,
    private readonly router: Router
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.errorMessage = navigation?.extras?.state?.errorMessage ?? null;
  }

  ngOnInit(): void {
    this.loggedIn = this.settings.isAuthenticated$;
    this.loggedIn.subscribe((loggedIn) => {
      if (loggedIn) {
        // Do not change string "Access denied in Fronted" as it is used in an alert rule
        this.appInsights.logException(new Error("Access denied in Fronted"), {
          isCandidate: this.settings.isCandidate,
          roles: this.settings,
          organizationId: this.settings.organizationId,
          permissions: this.settings.userPermissions,
        });
      }
    });
  }
}
